import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {AddFolderModel} from "../../models/add-folder.model";

@Component({
  selector: 'add-folder-modal',
  templateUrl: './add-folder-modal.component.html',
  styleUrls: ['./add-folder-modal.component.css']
})
export class AddFolderModalComponent implements OnInit {

  @Output() addFolderEvent = new EventEmitter<AddFolderModel>();
  @Output() closeEvent = new EventEmitter();
  @Output() folderChangedEvent = new EventEmitter();
  @Input() addFolderErrorMessage: string;
  addFolderForm: FormGroup;

  constructor() { }

  ngOnInit() {
    this.addFolderForm = new FormGroup({
      folder: new FormControl(''),
      tagType: new FormControl('ARTIST')
    });
    this.addFolderForm.valueChanges.subscribe(value => {
      this.folderChangedEvent.emit();
    });
  }

  addFolder() {
    this.addFolderEvent.emit(this.addFolderForm.value);
  }

  cancel($event) {
    if ($event.currentTarget === $event.target) {
      this.closeEvent.emit();
    }
  }

  getFolder(): FormControl {
    return this.addFolderForm.get('folder') as FormControl;
  }

}
